<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="ded"> </p>
<p class="ded"><span class="epub-sc">FOR GREG DORAN AND TONY HILL</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?24b56753